var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import OperationReportService from '../../api/OperationReportService';
import { billDefaultDate } from "../../helper/defaultDate";
import { UrlHelper } from '../../helper/UrlWrapper';
import { pageKeys, useTableSumData } from './hooks.js';
import TableList from './components/TableList.vue';
var OperationReport = (function (_super) {
    __extends(OperationReport, _super);
    function OperationReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = OperationReportService.getInstance();
        _this.fetchAction = _this.service.getTriumphList;
        _this.summaryListData = [];
        _this.listData = [];
        _this.tableHeight = document.documentElement.clientHeight - 220;
        _this.filter = {
            s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: billDefaultDate().End.format('yyyy-MM-dd'),
            keyword: '',
            sort_field: '',
            sort_type: ''
        };
        _this.total = 0;
        _this.sortColumns = [
            'invite_business_num',
            'invite_shop_num',
            'service_business_num',
            'service_shop_num',
            'new_order_business_num',
            'new_order_shop_num',
            'order_business_num',
            'order_shop_num',
            'sales_money',
            'receive_money'
        ];
        return _this;
    }
    OperationReport.prototype.created = function () {
    };
    OperationReport.prototype.search = function () {
        var _this = this;
        this.$refs.pagination && this.$refs.pagination.clear();
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    OperationReport.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getTriumphList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            console.log(res.data);
            _this.summaryListData = Array.isArray(res.data.data) ? res.data.data : res.data.data;
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    OperationReport.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.filter.sort_field = '';
            this.filter.sort_type = '';
        }
        else {
            this.filter.sort_field = prop;
            this.filter.sort_type = order === 'ascending' ? 'ASC ' : 'DESC';
        }
        this.getList();
    };
    OperationReport.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    OperationReport.prototype.exportResult = function () {
        var url = "supplierclientapi/performance/export?s_time=" + this.filter.s_time
            + '&e_time=' + this.filter.e_time
            + '&keyword=' + this.filter.keyword
            + '&sort_field=' + this.filter.sort_field
            + '&sort_type=' + this.filter.sort_type;
        console.log(url);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '业绩汇总', '业绩汇总导出']);
    };
    OperationReport.prototype.setSummary = function (params) {
        var res = useTableSumData(params, pageKeys['summary']);
        console.log('setSummary', res);
        return res;
    };
    OperationReport = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                TableList: TableList
            },
            methods: {},
        })
    ], OperationReport);
    return OperationReport;
}(Vue));
export default OperationReport;
